export default "__VITE_ASSET__2fbbb77e__"